import styled from 'styled-components'

export const ChipsContainer = styled.div`
  display: flex;
  position: absolute;
  top: 5px;
  left: 5px;

  & > * {
    margin-right: 5px;
  }
`
